import * as React from 'react';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { MobileTimePicker } from '@mui/x-date-pickers/MobileTimePicker';
import {
  Box, InputAdornment, TextField, Typography,
} from '@mui/material';

import './styles.scss';

interface PrimaryTimePickerProps {
  value: any;
  onChange:(value: any) => void;
  minTime?:any;
  maxTime?:any;
  label?:string;
  disabled?:boolean;
}

const style = {
  border: 0,
  borderRadius: '6px',
  fontSize: '18px',
  fontWeight: 500,
  outline: 'none',
  marginTop: '5px',
  width: '100%',
  '& .MuiOutlinedInput-input': {
    padding: '11px 14px',
  },
  '& .MuiOutlinedInput-root': {
    borderRadius: '6px',
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: '#CDCDCD',
      padding: '11px 14px',
    },
    '&.Mui-error .MuiOutlinedInput-notchedOutline': {
      borderColor: '#CDCDCD',
    },
    '&.Mui-disabled .MuiOutlinedInput-notchedOutline': {
      borderColor: '#CDCDCD',
      borderWidth: '1px',
    },
    '&:hover fieldset': {
      borderColor: '#171772',
      borderWidth: '1px',
    },
    '&.Mui-focused fieldset': {
      borderColor: '#171772',
      borderWidth: '1px',
    },
    '& .MuiButtonBase-root': {
      color: '#CDCDCD',
    },
  },
};

const activeMeridiemStyles = { color: 'secondary.main' };

const PrimaryTimePicker = React.forwardRef(
  ({
    onChange, value, minTime, maxTime, label, disabled,
  }: PrimaryTimePickerProps, _ref) => (
    <LocalizationProvider dateAdapter={AdapterMoment}>
      {label && <Typography variant="body1">{label}</Typography>}
      <MobileTimePicker
        value={value}
        ampmInClock
        disableIgnoringDatePartForTimeValidation
        minTime={minTime}
        maxTime={maxTime}
        onChange={onChange}
        disabled={disabled}
        renderInput={(params) => {
          const formatedParams = { ...params };
          const timeValue = formatedParams?.inputProps?.value;
          const timeMeridiem = timeValue?.substring(6, 8) || '';
          delete formatedParams?.inputProps?.value;
          return (
            <TextField
              sx={style}
              {...formatedParams}
              inputProps={{
                ...formatedParams.inputProps,
                placeholder: 'HH:MM',
              }}
              value={timeValue?.substring(0, 5) ?? ''}
              fullWidth
              // eslint-disable-next-line react/jsx-no-duplicate-props
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                      <Typography variant="body1" sx={timeMeridiem === 'AM' ? activeMeridiemStyles : { color: 'text.secondary' }}>AM</Typography>
                      <Typography
                        variant="body1"
                        sx={timeMeridiem === 'PM'
                          ? { ...activeMeridiemStyles, ml: 0.8 } : { color: 'text.secondary', ml: 0.8 }}
                      >
                        PM
                      </Typography>
                    </Box>
                  </InputAdornment>
                ),
              }}
            />
          );
        }}
      />
    </LocalizationProvider>
  ),
);

PrimaryTimePicker.defaultProps = {
  minTime: '',
  maxTime: '',
  label: '',
  disabled: false,
};
export default PrimaryTimePicker;
